document.querySelectorAll('.AlertInfo.AlertInfo--cookies').forEach((el) => {
    const isShow = !CookieUtil.get('is_cookie_accept');
    if(isShow) {
        el.classList.add('AlertInfo--active');
    }
    el.querySelector('button').addEventListener('click', () => {
        CookieUtil.set('is_cookie_accept', '1', Date(Date.now() + 3,1000*60*60*24*365), '/');
        el.classList.remove('AlertInfo--active');
    });
})
